export const getUrlParams = (params = '') => {
    const href = globalThis?.location?.href;
    return href ? new URL(href).searchParams.get(params) : null;
};
//# sourceMappingURL=getUrlParams.js.map